export default "__VITE_ASSET__NPlvYZCT__"